// extracted by mini-css-extract-plugin
export default {"container":"Header_container__0O2-v","header":"Header_header__3WwU8","logo":"Header_logo__YbplF","icon":"Header_icon__85SZJ","slideIn":"Header_slideIn__XLVAY"};